/* D.'s Nutz – Kartenkatalog im Shop.
   Daten kommen aus dem Backoffice (lager.ds-nutz.com/oeffentlich): alle Sets und Karten, ob eine Karte
   im Shop angeboten wird und der Link dorthin. Keine Preise; verfügbare Karten werden gold hervorgehoben. */
(function () {
  "use strict";
  var meta = document.querySelector('meta[name="dsn-api"]');
  var API = meta ? meta.content.replace(/\/$/, "") : "https://lager.ds-nutz.com/oeffentlich";
  var VARIANTS = { normal: "Normal", holo: "Holo", reverse: "Reverse", pokeball: "Pokéball", masterball: "Masterball",
    energy: "Energie-Muster", rocket: "Team Rocket", cosmos: "Cosmo", stempel: "Stempel", firstEdition: "1. Edition", wPromo: "Promo" };
  var RARITY = ["Common", "Uncommon", "Rare", "Holo Rare", "Double Rare", "Ultra Rare", "Illustration Rare", "ACE SPEC Rare",
    "Shiny Rare", "Shiny Ultra Rare", "Special Illustration Rare", "Hyper Rare", "Mega Attack Rare", "Mega Hyper Rare", "Secret Rare"];
  var setsPromise = null;

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function get(path) { return fetch(API + path, { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }); }
  function sets() { return setsPromise || (setsPromise = get("/sets")); }
  function allSets(d) { var out = []; d.serien.forEach(function (s) { s.sets.forEach(function (x) { x.serie = s.name; out.push(x); }); }); return out; }
  function fallbackImages(root) {
    root.querySelectorAll("img[data-fallback]").forEach(function (img) {
      if (img.dataset.bound) return;
      img.dataset.bound = "1";
      img.addEventListener("error", function () {
        var fb = img.getAttribute("data-fallback");
        if (fb && img.src !== fb) { img.src = fb; img.removeAttribute("data-fallback"); }
        else { var ph = document.createElement("span"); ph.className = "ph"; ph.textContent = img.getAttribute("data-ph") || img.alt || "Kein Bild"; img.replaceWith(ph); }
      });
    });
  }

  function tile(k) {
    var inner = '<span class="dsn-tile__img">' + (k.auf_lager ? '<span class="dsn-badge dsn-badge--in">Auf Lager</span>' : "") +
      '<img loading="lazy" alt="' + esc(k.name) + '" src="' + esc(k.bild) + '" data-fallback="' + esc(k.bild_en) + '"></span>' +
      '<span class="dsn-tile__name">' + esc(k.name) + "</span>" +
      '<span class="dsn-tile__meta">' + esc([k.code, k.nummer].filter(Boolean).join(" ")) + (k.seltenheit ? " · " + esc(k.seltenheit) : "") + "</span>";
    return k.auf_lager
      ? '<li><a class="dsn-tile dsn-tile--in" href="' + esc(k.link) + '">' + inner + "</a></li>"
      : '<li><div class="dsn-tile dsn-tile--out" title="Nicht auf Lager">' + inner + "</div></li>";
  }
  function setTile(s, href) {
    var logo = s.logo ? '<img loading="lazy" alt="' + esc(s.name) + '" data-ph="' + esc(s.code || "") + '" src="' + esc(s.logo) + '" data-fallback="' + esc(s.logo_en) + '">' : '<span class="ph">' + esc(s.code || "") + "</span>";
    var attrs = href ? 'href="' + esc(href + "#set=" + s.id) + '"' : 'href="#set=' + esc(s.id) + '"';
    return '<a class="dsn-set" ' + attrs + '><span class="dsn-set__logo">' + logo + '</span><span class="dsn-set__name">' + esc(s.name) + "</span>" +
      '<span class="dsn-set__meta"><span>' + esc([s.code, s.jahr].filter(Boolean).join(" · ")) + " · " + s.karten + " Karten</span>" +
      (s.auf_lager ? '<span class="dsn-set__stock">' + s.auf_lager + " auf Lager</span>" : "") + "</span></a>";
  }

  /* ---- Suche in den Karten im Shop (Seite „Karten“): Freitext, mit Preis ---- */
  function euro(v) { var n = parseFloat(v); return isNaN(n) ? "" : n.toFixed(2).replace(".", ",") + " €"; }
  function shopTile(k) {
    var img = k.bild ? '<img loading="lazy" alt="' + esc(k.name) + '" src="' + esc(k.bild) + '" data-fallback="' + esc(k.bild_en) + '">' : '<span class="ph">' + esc(k.name) + "</span>";
    var meta = [k.code, k.nummer].filter(Boolean).join(" ");
    var extra = [k.variante && k.variante !== "Normal" ? k.variante : "", k.sprache, k.zustand].filter(Boolean).join(" · ");
    return '<li><a class="dsn-tile dsn-tile--in" href="' + esc(k.link) + '" title="' + esc(k.titel) + '"><span class="dsn-tile__img">' + img +
      '</span><span class="dsn-tile__name">' + esc(k.name) + '</span><span class="dsn-tile__meta">' + esc(meta) + (extra ? " · " + esc(extra) : "") +
      '</span><span class="dsn-tile__price">' + esc(euro(k.preis)) + "</span></a></li>";
  }
  function setupStockSearch(root) {
    var input = root.querySelector(".dsn-search__input"), list = root.querySelector(".dsn-grid"), status = root.querySelector(".dsn-status");
    var timer = null, seq = 0, lang = "";
    root.querySelectorAll(".dsn-lang").forEach(function (b) {
      b.addEventListener("click", function () {
        lang = b.getAttribute("data-lang");
        root.querySelectorAll(".dsn-lang").forEach(function (x) { x.classList.toggle("is-on", x === b); });
        run();
      });
    });
    function run() {
      var q = input.value.trim();
      if (q.length < 2 && !lang) { list.innerHTML = ""; status.textContent = ""; return; }
      var mine = ++seq;
      status.textContent = "Suche …";
      get("/lagersuche?q=" + encodeURIComponent(q) + (lang ? "&sprache=" + lang : "")).then(function (d) {
        if (mine !== seq) return;
        var n = d.anzahl || 0;
        status.textContent = n ? (n === 1 ? "1 Karte gefunden" : n + " Karten gefunden") + (n > d.karten.length ? " – die ersten " + d.karten.length + " werden gezeigt" : "") +
          ". Unten findest du alle Karten mit Filtern." : "Keine passende Karte im Shop. Tipp: nur den Namen oder nur die Nummer eingeben.";
        list.innerHTML = d.karten.map(shopTile).join("");
        fallbackImages(list);
      }).catch(function () { if (mine === seq) status.textContent = "Die Suche ist gerade nicht erreichbar."; });
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { clearTimeout(timer); run(); } });
    var start = new URLSearchParams(location.search).get("suche");
    if (start) { input.value = start; run(); }
  }

  /* ---- Suche (Startseite und Katalog) ---- */
  function setupSearch(root) {
    var input = root.querySelector(".dsn-search__input"), list = root.querySelector(".dsn-grid"), status = root.querySelector(".dsn-status");
    var timer = null, seq = 0;
    function run() {
      var q = input.value.trim();
      root.dispatchEvent(new CustomEvent("dsn:query", { bubbles: true, detail: q }));
      if (q.length < 2) { list.innerHTML = ""; status.textContent = ""; return; }
      var mine = ++seq;
      status.textContent = "Suche …";
      get("/kartensuche?q=" + encodeURIComponent(q)).then(function (d) {
        if (mine !== seq) return;
        var cards = (d.karten || []).slice().sort(function (a, b) { return (b.auf_lager ? 1 : 0) - (a.auf_lager ? 1 : 0); });
        if (!cards.length) { list.innerHTML = ""; status.textContent = root.hasAttribute("data-inline") ? "Keine Karte mit diesem Namen – vielleicht ein Set? Siehe unten." : "Keine Karte gefunden. Versuch es mit Set-Kürzel und Nummer, z. B. „PFL 103“."; return; }
        var n = cards.filter(function (k) { return k.auf_lager; }).length;
        status.textContent = cards.length + " Karten gefunden" + (d.hinweis ? " (" + d.hinweis + ")" : "") + " · " + n + " auf Lager";
        list.innerHTML = cards.map(tile).join("");
        fallbackImages(list);
      }).catch(function (e) { if (mine === seq) status.textContent = e === 429 ? "Zu viele Suchen auf einmal – bitte kurz warten." : "Die Suche ist gerade nicht erreichbar."; });
    }
    input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 280); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { clearTimeout(timer); run(); } });
  }

  /* ---- Neueste Sets (Startseite) ---- */
  function setupSetStrip(root) {
    var limit = parseInt(root.getAttribute("data-limit") || "12", 10), href = root.getAttribute("data-href") || "/pages/katalog";
    sets().then(function (d) {
      var list = allSets(d).filter(function (s) { return s.datum; }).sort(function (a, b) { return a.datum < b.datum ? 1 : -1; });
      root.innerHTML = list.slice(0, limit).map(function (s) { return setTile(s, href); }).join("");
      fallbackImages(root);
    }).catch(function () { root.innerHTML = '<p class="dsn-empty">Die Sets sind gerade nicht erreichbar.</p>'; });
  }
  function setupFacts(root) {
    sets().then(function (d) {
      var a = root.querySelector('[data-dsn-count="auf_lager"]'), s = root.querySelector('[data-dsn-count="sets"]');
      if (a) a.textContent = (d.auf_lager || 0).toLocaleString("de-DE");
      if (s) s.textContent = allSets(d).length.toLocaleString("de-DE");
    }).catch(function () {});
  }

  /* ---- Katalog: Übersicht aller Sets oder ein Set ---- */
  function setupBrowser(root) {
    var section = root.closest("[data-dsn-katalog]") || document;
    var state = { query: "", onlyStock: false, variant: "", sort: "nummer" };
    section.addEventListener("dsn:query", function (e) { state.query = e.detail.toLowerCase(); if (!current()) overview(); });
    function current() { var m = location.hash.match(/set=([^&]+)/); return m ? decodeURIComponent(m[1]) : null; }

    function overview() {
      sets().then(function (d) {
        var q = state.query;
        var html = '<div class="dsn-cat__bar"><button type="button" class="dsn-chip" data-only aria-pressed="' + state.onlyStock + '">Nur Sets mit Karten auf Lager</button>' +
          '<span class="dsn-status" style="margin:0">' + allSets(d).length + " Sets · " + (d.auf_lager || 0) + " verschiedene Karten auf Lager</span></div>";
        var shown = 0;
        d.serien.forEach(function (sr) {
          var list = sr.sets.filter(function (s) {
            if (state.onlyStock && !s.auf_lager) return false;
            if (!q) return true;
            return [s.name, s.name_en, s.code, sr.name].filter(Boolean).join(" ").toLowerCase().indexOf(q) >= 0;
          });
          if (!list.length) return;
          shown += list.length;
          html += '<h2 class="dsn-series">' + esc(sr.name) + '</h2><div class="dsn-setgrid">' + list.map(function (s) { return setTile(s); }).join("") + "</div>";
        });
        if (!shown) html += '<p class="dsn-empty">Kein Set gefunden.</p>';
        root.innerHTML = html;
        fallbackImages(root);
        root.querySelector("[data-only]").addEventListener("click", function () { state.onlyStock = !state.onlyStock; overview(); });
      }).catch(function () { root.innerHTML = '<p class="dsn-empty">Der Katalog ist gerade nicht erreichbar. Bitte später noch einmal versuchen.</p>'; });
    }

    function setView(id) {
      root.innerHTML = '<p class="dsn-status">Lade Set …</p>';
      get("/set/" + encodeURIComponent(id)).then(function (d) {
        var cards = d.karten, s = d.set;
        var have = cards.filter(function (k) { return k.auf_lager; }).length;
        var present = {};
        cards.forEach(function (k) { (k.varianten || []).forEach(function (v) { present[v] = (present[v] || 0) + 1; }); });
        var chips = Object.keys(VARIANTS).filter(function (v) { return present[v] && v !== "normal"; });
        function draw() {
          var list = cards.filter(function (k) {
            if (state.onlyStock && !k.auf_lager) return false;
            if (state.variant && (k.varianten || []).indexOf(state.variant) < 0) return false;
            return true;
          });
          var key = state.sort;
          list.sort(function (a, b) {
            if (key === "lager") return (b.auf_lager ? 1 : 0) - (a.auf_lager ? 1 : 0);
            if (key === "name") return a.name.localeCompare(b.name, "de");
            if (key === "selten") return RARITY.indexOf(b.seltenheit) - RARITY.indexOf(a.seltenheit);
            return 0;
          });
          grid.innerHTML = list.length ? list.map(tile).join("") : '<li class="dsn-empty">Keine Karte für diesen Filter.</li>';
          fallbackImages(grid);
        }
        var logo = s.logo ? '<img alt="' + esc(s.name) + '" data-ph="' + esc(s.code || "") + '" src="' + esc(s.logo) + '" data-fallback="' + esc(s.logo_en) + '">' : "";
        root.innerHTML = '<button type="button" class="dsn-back">Alle Sets</button>' +
          '<div class="dsn-sethead" style="margin-top:12px">' + logo + '<div><h2>' + esc(s.name) + '</h2><p class="dsn-sub">' +
          esc([s.code, s.datum ? s.datum.slice(0, 4) : ""].filter(Boolean).join(" · ")) + " · " + cards.length + " Karten · <b style=\"color:var(--dsn-gold)\">" + have + " auf Lager</b></p></div></div>" +
          '<div class="dsn-cat__bar"><button type="button" class="dsn-chip" data-only aria-pressed="' + state.onlyStock + '">Nur auf Lager</button>' +
          '<button type="button" class="dsn-chip" data-v="" aria-pressed="' + !state.variant + '">Alle Varianten</button>' +
          chips.map(function (v) { return '<button type="button" class="dsn-chip" data-v="' + v + '" aria-pressed="' + (state.variant === v) + '">' + VARIANTS[v] + "</button>"; }).join("") +
          '<select class="dsn-select" aria-label="Sortierung"><option value="nummer">Nummer</option><option value="lager">Auf Lager zuerst</option><option value="selten">Seltenheit</option><option value="name">Name</option></select></div>' +
          '<ul class="dsn-grid" role="list"></ul>';
        var grid = root.querySelector(".dsn-grid");
        root.querySelector(".dsn-select").value = state.sort;
        root.querySelector(".dsn-back").addEventListener("click", function () { history.pushState(null, "", location.pathname); route(); });
        root.querySelector("[data-only]").addEventListener("click", function (e) { state.onlyStock = !state.onlyStock; e.target.setAttribute("aria-pressed", state.onlyStock); draw(); });
        root.querySelectorAll("[data-v]").forEach(function (b) {
          b.addEventListener("click", function () {
            state.variant = b.getAttribute("data-v");
            root.querySelectorAll("[data-v]").forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
            draw();
          });
        });
        root.querySelector(".dsn-select").addEventListener("change", function (e) { state.sort = e.target.value; draw(); });
        fallbackImages(root);
        draw();
        root.scrollIntoView({ block: "start", behavior: "smooth" });
      }).catch(function () { root.innerHTML = '<p class="dsn-empty">Dieses Set ist gerade nicht erreichbar.</p>'; });
    }

    function route() { var id = current(); state.variant = ""; if (id) setView(id); else overview(); }
    window.addEventListener("hashchange", route);
    route();
  }

  function init() {
    document.querySelectorAll("[data-dsn-search]").forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = 1; setupSearch(el); } });
    document.querySelectorAll("[data-dsn-lagersuche]").forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = 1; setupStockSearch(el); } });
    document.querySelectorAll("[data-dsn-sets]").forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = 1; setupSetStrip(el); } });
    document.querySelectorAll("[data-dsn-facts]").forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = 1; setupFacts(el); } });
    document.querySelectorAll("[data-dsn-browser]").forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = 1; setupBrowser(el); } });
    fallbackImages(document);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
